import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  clearPageData,
  getPageDescriptionList,
} from "../../store/Slice/pageDescriptionSlice";

const HowItWorks = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const { pageDescriptionData, loading } = useSelector(
    (state) => state.pageDescriptionList
  );

  const howItWorkPath = pathname === "/" ? "Home" : "";

  const decodedString = React.useMemo(() => {
    const encoded = pageDescriptionData?.data?.[0]?.tDescription;
    if (pageDescriptionData?.code === 200 && encoded) {
      try {
        return atob(encoded);
      } catch (err) {
        // console.error("Base64 decoding failed:", err);
      }
    }
    return "";
  }, [pageDescriptionData]);

  React.useEffect(() => {
    dispatch(clearPageData());
    dispatch(
      getPageDescriptionList({
        vSlug: howItWorkPath,
        eStatus: "Active",
        eDelete: "No",
      })
    );
  }, [dispatch, howItWorkPath]);

  const handleClick = React.useCallback(
    (event) => {
      if (event.target.closest(".success-orangebtn")) {
        navigate("/book-now");
      }
    },
    [navigate]
  );

  React.useEffect(() => {
    const parent = document.getElementById("book-now-button");
    if (!parent) return;

    parent.addEventListener("click", handleClick);
    return () => parent.removeEventListener("click", handleClick);
  }, [decodedString, handleClick]);

  if (loading) return <div style={{ height: "1029px" }}></div>;

  return decodedString ? (
    <div
      id="book-now-button"
      dangerouslySetInnerHTML={{ __html: decodedString }}
      className="pb-50"
    />
  ) : (
    <div className="col-12">
      <p className="text-center py-2">No Data Found</p>
    </div>
  );
};

export default HowItWorks;
